// src/components/common/SearchAndFilter.tsx
import { Search, X, Filter } from 'lucide-react';
import { SearchableSelect } from '../ui/searchable-select';
interface SearchAndFilterProps<T extends string> {
    searchTerm: string;
    onSearchChange: (value: string) => void;
    onClearSearch: () => void;
    statusFilter?: T;
    onStatusChange?: (value: any) => void;
    filterOptions: Array<{ value: T; label: string }>;
    searchPlaceholder?: string;
    filterPlaceholder?: string;
}
export function SearchAndFilter<T extends string>({
    searchTerm,
    onSearchChange,
    onClearSearch,
    statusFilter,
    onStatusChange,
    filterOptions,
    searchPlaceholder = 'Search...',
    filterPlaceholder = 'Filter...',
}: SearchAndFilterProps<T>) {
    return (
        <div className="flex flex-col md:flex-row gap-4 bg-[#0B1623] border border-white/10 p-4 rounded-2xl">
            <div className="relative flex-1">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <input
                    type="text"
                    placeholder={searchPlaceholder}
                    value={searchTerm}
                    onChange={(e) => onSearchChange(e.target.value)}
                    className="w-full pl-10 pr-10 py-2.5 bg-black/20 border border-white/10 rounded-xl focus:outline-none focus:border-cyan-500 text-sm text-white placeholder:text-slate-500 transition-all"
                />
                {searchTerm && (
                    <button
                        onClick={onClearSearch}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white transition-colors"
                        aria-label="Clear search"
                    >
                        <X className="w-4 h-4" />
                    </button>
                )}
            </div>
            {statusFilter && onStatusChange &&
                <div className="flex items-center gap-2">
                    <Filter className="w-4 h-4 text-slate-400" />
                    <SearchableSelect
                        options={filterOptions}
                        value={statusFilter}
                        onChange={onStatusChange}
                        searchPlaceholder={filterPlaceholder}
                        className="bg-black/20 border-white/10 text-white"
                    />
                </div>
            }
        </div>
    );
}